import Link from 'next/link'

const NewTabLink = ({ href, children, ...extra }) => (
  <Link href={href}>
    <a target='_blank' rel='noreferrer' {...extra}>{children}</a>
  </Link>
)

export default NewTabLink
